module.exports = __webpack_public_path__ + "img/team2.500c6027.png";